module.exports = __webpack_public_path__ + "static/media/other_icon.95e9c096.svg";